export const ORGANIZATION_LOADED = "ORGANIZATION_LOADED";

export const STRIPE_LOADED = "STRIPE_LOADED";

export const CLIENT_SECRET_LOADED = "CLIENT_SECRET_LOADED";

export const NUM_SEATS_CHANGED = "NUM_SEATS_CHANGED";

export const TOGGLE_CONFIRMATION = "TOGGLE_CONFIRMATION";

export const INTERVAL_CHANGED = "INTERVAL_CHANGED";

export const PRICE_SELECTED = "PRICE_SELECTED";

export const CURRENT_SUBSCRIPTION_LOADED = "CURRENT_SUBSCRIPTION_LOADED";

export const CURRENT_SUBSCRIPTION_STRIPE_DATA_LOADED = "CURRENT_SUBSCRIPTION_STRIPE_DATA_LOADED";

export const PAYMENT_METHODS_LOADED = "PAYMENT_METHODS_LOADED";

export const PAYMENT_METHOD_SELECTED = "PAYMENT_METHOD_SELECTED";

export const TOGGLE_DOWNGRADE_DIALOG = "TOGGLE_DOWNGRADE_DIALOG";

export const TOGGLE_SEAT_OVERFLOW_DIALOG = "TOGGLE_SEAT_OVERFLOW_DIALOG";

export const TOGGLE_ROLE_OVERFLOW_DIALOG = "TOGGLE_ROLE_OVERFLOW_DIALOG";

export const SELECTED_SUBSCRIPTION_PARAMETERS_LOADED = "SELECTED_SUBSCRIPTION_PARAMETERS_LOADED";

export const TOGGLE_PROJECT_OVERFLOW_DIALOG = "TOGGLE_PROJECT_OVERFLOW_DIALOG";

export const NUM_ACTIVE_PROJECTS_LOADED = "NUM_ACTIVE_PROJECTS_LOADED";

export const TOGGLE_ADD_NEW_CARD_DIALOG = "TOGGLE_ADD_NEW_CARD_DIALOG";

export const NEW_CARD_ADDED = "NEW_CARD_ADDED";

export const NEW_PRICE_DATA_LOADED = "NEW_PRICE_DATA_LOADED";

export const NEW_PRICE_DATA_LOADING = "NEW_PRICE_DATA_LOADING";

export const PRICE_CHANGE_SUCCESSFUL = "PRICE_CHANGE_SUCCESSFUL";

export const ORGANIZATION_STRIPE_DATA_LOADED = "ORGANIZATION_STRIPE_DATA_LOADED";

export const SET_BILLING_INFORMATION = "SET_BILLING_INFORMATION";

export const SET_TAX_INFO = "SET_TAX_INFO";

export const PAYMENT_INFORMATION_VALID_STATE_CHANGED = "PAYMENT_INFORMATION_VALID_STATE_CHANGED";

export const SUBSCRIPTIONS_LOADED = "SUBSCRIPTIONS_LOADED";